<template>
  <div class="box-container" style="width: 100%; height: 100%; max-width: 100%; max-height: 100vh">
    <v-dialog class="ma-0 pa-0" v-if="dialogImg" :width="largePicWidth" v-model="dialogImg">
      <v-card class="ma-0 pa-0 row-content flex-grow-1" align="center" justify="center">
        <v-icon color="red" @click="dialogImg = false" style="background-color: white; position: fixed; right: 10px; top: 10px; left: auto; bottom: auto">mdi-close</v-icon>
        <v-icon @click="largePicWidth -= 50" style="background-color: white; position: fixed; right: 40px; top: 10px; left: auto; bottom: auto">mdi-minus-circle</v-icon>
        <v-icon @click="largePicWidth += 50" style="background-color: white; position: fixed; right: 70px; top: 10px; left: auto; bottom: auto">mdi-plus-circle</v-icon>
        <v-img :src="currentItem.img" :width="largePicWidth" height="auto"></v-img>
      </v-card>
    </v-dialog>
    <v-card class="row-header ma-0 pa-0 elevation-15">
      <v-row dense class="ma-2 pa-0" :class="isOnMobile ? '' : 'mr-10'">
        <t-button v-if="chosenModel" :class="'ma-0 pa-0 mx-3'" :btnText="isOnMobile ? '' : 'Избор на модел ФУ'" :btnIcon="'mdi-arrow-left'" @click.native="chosenModel = null" @mouseover.native="currentItem = chosenModel"></t-button>
        <!-- <v-btn outlined class="ma-0 mx-3" v-if="chosenModel" @click="chosenModel = null" @mouseover="currentItem = chosenModel">
          <v-icon left small>mdi-arrow-left</v-icon>
          <span>Избор на модел ФУ</span>
        </v-btn> -->
        <v-autocomplete class="ma-0 pa-0" v-if="searchItems.length > 0" clearable @click:clear="clearSearch" clear-icon="mdi-close" no-data-text="Не са намерени компоненти" v-model="searchItem" @input="search" :items="searchItems" item-text="name" return-object hide-details single-line></v-autocomplete>
        <v-btn text @click="search" class="ma-0 pa-0 px-3">
          <v-icon left>mdi-magnify</v-icon>
          <span>{{ isOnMobile ? "" : "Търси" }}</span>
        </v-btn>
        <!-- <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>-->
      </v-row>
      <!-- <t-divider></t-divider> -->
    </v-card>
    <div class="row-content">
      <div v-if="chosenModel" class="box-container-horizontal" style="height: 100%">
        <div class="row-content elevation-10">
          <v-treeview ref="refTree" open-on-click class="ma-0 pa-0" v-if="treeroot.length > 0" :items="treeroot" item-key="uid" return-object multiple-active :open.sync="openIds" :active.sync="activeIds" dense style="height: 200px; cursor: pointer">
            <!-- <v-treeview ref="refTree" class="ma-0 pa-0" v-if="root.length > 0" :items="root" item-key="uid" return-object multiple-active :open.sync="openIds" :active.sync="activeIds" dense style="height: 200px; cursor: pointer"> -->
            <template v-slot:label="{ item }">
              <!-- <span :style="currentItem == item? 'font-weight: bold':''" @mouseover="mouseOver(item)" @click="addChildren(item, true)">{{ item.name + (item.desc?(' ' + item.desc): '') }}</span> -->
              <span :style="currentItem == item ? 'font-weight: bold' : ''" @mouseover="mouseOver(item)">{{ item.name + (item.desc ? " " + item.desc : "") }}</span>
              <v-icon v-if="item.img" right>mdi-magnify</v-icon>
            </template>
            <template v-slot:prepend="{ item, open }">
              <v-icon v-if="item.hasChild">{{ open ? "mdi-folder-open" : "mdi-folder" }}</v-icon>
              <v-icon v-else>mdi-tune-vertical</v-icon>
              <!-- <v-img :width="24" :height="24" v-if="item.imageLoaded" :src="item.img"></v-img>
            <v-icon v-else-if="item.hasChild">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
              <v-icon v-else>mdi-tune-vertical</v-icon>-->
            </template>
          </v-treeview>
        </div>
        <div class="row-header customscroll ma-0 pa-3" align="center" style="min-width: 400px; overflow-x: hidden">
          <div v-if="currentItem" class="ma-0 my-2" align-text="start" style="display: block; width: 360px; height: 200px">
            <!-- <span class="snl title" style="width: 100%; text-align: center; text-decoration: underline;">Информация за компонента</span> -->
            <span class="snl mb-2" align="center" style="font-weight: bold">{{ currentItem.name }}</span>
            <div style="display: flex">
              <span class="snl">{{ "Парт номер: " + currentItem.id + " " }}</span>
              <v-btn outlined rounded small @click="copyPartNumber(currentItem)"> <v-icon left small>mdi-content-copy</v-icon>Копирай </v-btn>
            </div>
            <div class="snl" v-if="currentItem.qty != 0">
              <span>{{ "Количество в текущия компонент: " }}</span>
              <span style="font-weight: bold">{{ currentItem.qty }}</span>
            </div>
            <!-- <div class="snl" v-if="currentItem.qty != 0">
              <span>{{ "Общо количество в продукта: "}}</span>
              <span style="font-weight: bold">{{ getTotalQty(currentItem) }}</span>
            </div>-->
            <span class="snl" v-if="currentItem.desc">{{ "Описание:\n" + currentItem.desc }}</span>
            <v-row class="ma-1" align="center" justify="center">
              <v-card class="ma-0 mt-2" align="center" justify="center" :width="350">
                <v-img v-if="currentItem.img" class="ma-0 pa-0" @error="setImageNotLoaded" @load="setImageLoaded" style="cursor: pointer" @click="showImage()" alt="Зареждане..." :src="currentItem.img" :width="350"></v-img>
                <v-img v-else class="ma-0 pa-0" alt="Зареждане..." :src="MissingPhoto" :width="350">
                  <!-- <v-icon color="red" @click="dialogImg = false" style="background-color: white; position: absolute; right: 10px; top : 10px; left: auto; bottom: auto;">mdi-close</v-icon> -->
                </v-img>
              </v-card>
            </v-row>
            <div class="mt-2">
              <template v-for="(a, ax) in getAnalogs(currentItem)">
                <span v-if="ax == 0" :key="'kkk' + ax" class="snl">Аналози в текущия компонент:</span>
                <span :key="'ssss' + ax" class="body-2 snl mt-2" style="font-weight: bold">{{ a.name }}</span>
                <div :key="'d' + ax" style="display: flex">
                  <span class="body-2 snl">{{ "Парт номер: " + a.id + " " }}</span>
                  <v-btn outlined rounded x-small @click="copyPartNumber(a)"> <v-icon left small>mdi-content-copy</v-icon>Копирай </v-btn>
                </div>
              </template>
              <template v-if="currentItem.analog">
                <span class="snl">Този компонент е аналог (заместител) на предишния компонент в списъка.</span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <v-row v-else class="ma-0 pa-0">
        <v-col cols="12" lg="3" md="4" sm="4" xs="12" v-for="(m, idx) in models" :key="idx">
          <v-card class="mx-auto" justify="center" align="center" max-width="250" style="cursor: pointer" @click="chooseModel(m.name)">
            <v-img justify="center" class="align-end" :width="220" :height="220" contain :src="m.img"></v-img>
            <v-card-title class="title-style justify-center">{{ m.name }}</v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-if="chosenModel" class="row-header elevation-20">
      <!-- <t-divider></t-divider> -->
      <div dense class="ma-2 pa-0">
        <span class="body-2" style="white-space: pre; font-weight: bold">{{ "Текущ компонент: " }}</span>
        <span class="body-2" v-if="currentItem">{{ (chosenModel ? chosenModel.name + " \\ " : "") + [...getParents(currentItem).map((p) => p.name), currentItem.name].join(" \\ ") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import HTTPSender from "../../js/HTTPSender";
var MissingPhoto = require("../../assets/img/main/missing_photo.png");
//const operators = ["A1", "Telenor", "Vivacom"];
const zeros = "000000000000";

export default {
  data() {
    return {
      searchText: "",
      searchItem: null,
      searchItems: [],
      dialogImg: false,
      currentItem: null,
      BOM: [],
      MissingPhoto: MissingPhoto,
      UniqueBOM: [],
      root: [],
      openIds: [],
      activeIds: [],
      modelNames: [],
      models: [],
      chosenModel: null,
      largePicWidth: 500,
    };
  },
  methods: {
    getTotalQty(item) {
      return this.root
        .filter((i) => i.id == item.id)
        .map((i) => i.qty)
        .sum();
    },
    getAnalogs(item) {
      if (item.qty != 0) {
        var items = [];
        var ixx = this.BOM.indexOf(item);
        if (ixx > -1) {
          var idx = ixx + 1;
          while (this.BOM[idx].qty == 0) {
            items.push(this.BOM[idx]);
            idx++;
          }
          return items;
        }
      }
      return [];
    },
    copyPartNumber(item) {
      item.id.copyToClipboard();
      this.dialogLoader.showInfo("Парт номер " + item.id + " е записан в клипборда.", { timeout: 2000 });
    },
    search() {
      if (this.searchItem) {
        //var item = this.searchItem;
        if (this.chosenModel) {
          var items = this.searchItems.filter((i) => i.id == this.searchItem.id);
          this.processSearch(items);
        } else {
          var uqRoots = this.BOM.filter((i) => i.id == this.searchItem.id)
            .map((r) => r.rootid)
            .unique();
          //this.modelNames = this.root;
          var items2 = this.BOM.filter((i) => uqRoots.indexOf(i.id) != -1)
            .map((r) => r.name.split("|")[0].trim())
            .unique();
          if (items2.length == -1) {
            //if (items2.length == 1) { // ако e намерен само един модел - избираме го директно
            this.$nextTick(() => {
              this.chooseModel(items2[0]);
            });
          } else {
            this.dialog.show(
              "picker-view",
              items2,
              {
                title: "Компонента е открит в следните устройства",
                buttonOKText: "",
                buttonCancelText: "",
              },
              (result) => {
                this.$nextTick(() => {
                  this.chooseModel(result);
                });

                // this.chosenModel = result;
                // this.$nextTick(() => {
                //   var items3 = this.BOM.filter(i => i.id == this.searchItem.id && this.chosenModel.id == i.rootid && this.chosenModel.id != i.id);
                //   console.log(items3.map(i => i.name));
                //   this.processSearch(items3);
                // });
              },
            );
          }
        }
      }
    },
    processSearch(items) {
      this.$nextTick(() => {
        var temp = [];
        var tempActive = [];
        items.forEach((item) => {
          //   while (item.isAnalog) {
          //     item = this.BOM[this.BOM.indexOf(item) - 1];
          //   }
          tempActive.push(item);
          this.currentItem = item;
          while (item) {
            temp.splice(0, 0, item);
            item = this.BOM.find((i) => i.id == item.parentid);
          }
        });
        // console.log(JSON.stringify(temp.map(u => u.id + " " + u.name + "  " + u.parentid)));
        // this.root.forEach(r => r.children.splice(0, r.children.length));
        // for (var i = 0; i < temp.length - 1; i++) {
        //   this.addChildren(temp[i]);
        // }
        this.$nextTick(() => {
          this.openIds = temp;
          //   this.$refs.refTree.updateAll(true);
          this.$nextTick(() => {
            this.activeIds = tempActive;
            // console.log(this.openIds.map(i=>i.name))
            //console.log(this.activeIds.map(i=>i.name))
          });
        });
      });
    },
    clearSearch() {
      this.activeIds = [];
      // var open = [];
      // if (exception) {
      //   open = this.getParents(exception);
      // }
      // if (exception) {
      //   for (var i = this.openIds.length - 1; i >= 0; i--) {
      //     var r = this.openIds[i];
      //     r.children.splice(0, r.children.length);
      //   }
      // } else {
      //   this.root.forEach(r => {
      //     r.children.splice(0, r.children.length);
      //   });
      // }
      // if (exception) {
      //   open.forEach(o => this.addChildren(o));
      //   open.push(exception);
      // }
      // return open;
    },
    mouseOver(item) {
      this.currentItem = item;
    },
    addChildren(item, manual) {
      if (item.children.length == 0) {
        var children = this.BOM.filter((b) => !b.analog && b.parentid == item.id);
        children.forEach((c) => {
          c.currentparentid = item.id;
        });
        item.children.push(...children);
      } else {
        item.children.splice(0, item.children.length);
      }
      if (manual) {
        this.openIds = this.clearSearch(item);
        this.$nextTick(() => {
          this.$refs.refTree.updateAll(true);
          this.$nextTick(() => {
            this.activeIds = [item];
          });
        });
      }
    },
    showImage() {
      this.dialogImg = true;
    },
    setImageLoaded() {
      this.currentItem.imageLoaded = true;
    },
    setImageNotLoaded() {
      var orig = this.BOM.find((i) => i.id == this.currentItem.id);
      if (orig.img.contains(".jpg") && this.currentItem.img.contains(".jpg")) this.currentItem.img = this.currentItem.img.replace(".jpg", ".JPG");
      if (orig.img.contains(".JPG") && this.currentItem.img.contains(".JPG")) this.currentItem.img = this.currentItem.img.replace(".JPG", ".jpg");
      if (orig.img.contains(".png") && this.currentItem.img.contains(".png")) this.currentItem.img = this.currentItem.img.replace(".png", ".PNG");
      if (orig.img.contains(".PNG") && this.currentItem.img.contains(".PNG")) this.currentItem.img = this.currentItem.img.replace(".PNG", ".png");
    },
    getParents(item) {
      var parents = [];
      var parent = this.BOM.find((i) => i.id == item.currentparentid);
      while (parent) {
        parents.splice(0, 0, parent);
        parent = this.BOM.find((i) => i.id == parent.currentparentid);
      }
      return parents;
    },
    loadTree() {
      this.BOM = this.BOM.filter((b) => !b.name.contains("Спряно от "));
      Array.from(this.BOM).map((it, i) => {
        this.$set(this.BOM[i], "image", "https://a.tremol.bg/_" + this.BOM[i].image);
        this.$set(this.BOM[i], "children", []);
        this.$set(this.BOM[i], "toString", () => this.BOM[i].name ?? "");
        //this.$set(this.BOM[i], "name_full", this.BOM[i].id + " " + this.BOM[i].name + " " + this.BOM[i].desc);
      });
      this.root = this.BOM.filter((b) => b.parentid == zeros || b.parentid == "0").sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      this.modelNames = this.root
        .map((r) => r.name.replace("Резервни Части", "").replace("-V2", "").replace(" V2", "").trim())
        .unique()
        .sort((a, b) => {
          if (a.endsWith("KL") && b.endsWith("V-KL")) return -1;
          else if (a.endsWith("V-KL") && b.endsWith("KL")) return 1;
          else if (!a.endsWith("KL") && b.endsWith(" V")) return 1;
          else if (a.endsWith("KL") && b.endsWith("KL")) {
            return a.localeCompare(b);
            // if (a < b) return -1;
            // else if (a > b) return 1;
            // else 0;
          } else if (b.endsWith("KL")) return 1;
          else if (a.endsWith("KL")) return -1;
          else return a.localeCompare(b);
          //   else if (a < b) return -1;
          //   else if (a > b) return 1;
          //   else 0;
        });
      this.models = [];
      for (var i = this.modelNames.length - 1; i >= 0; i--) {
        var m = this.modelNames[i];
        var tmpImg = null;
        try {
          tmpImg = require("../../assets/img/" + m.replace("TREMOL", "Tremol") + ".png");
          this.models.push({ name: m, img: tmpImg });
          //TODO
          //   this.models.sort((a, b) => {
          //     return  b.name - a.name;
          //   });
        } catch {
          this.modelNames.splice(i, 1);
          /**ignored */
        }
      }
      var bomsUnique = {};
      //   this.BOM.forEach(e => {
      //     var bn = this.BOM.find(b => b.id == e.rootid)
      //       .name.split("|")[0]
      //       .trim();
      //     if (this.models.find(m => m.name == bn)) {
      //       bomsUnique[e.id] = e;
      //     }
      //   });

      this.BOM.forEach((e) => {
        if (!bomsUnique[e.id]) bomsUnique[e.id] = e;
      });

      this.UniqueBOM = Object.values(bomsUnique).sort((a, b) => {
        if (a.parentid == zeros && b.parentid != zeros) return -1;
        else if (a.parentid != zeros && b.parentid == zeros) return 1;
        return a.name.localeCompare(b.name);
      });
      this.searchItems = this.UniqueBOM;
    },
    chooseModel(m) {
      var dev = this.root.find((r) => r.name == m);
      if (dev) {
        this.chosenModel = dev;
        this.currentItem = dev;
      }

      // var modelsInBom = this.root.filter(
      //   r =>
      //     r.name
      //       .split("|")[0]
      //       .trim()
      //       .toLowerCase() == m.toLowerCase(),
      // );
      // this.dialog.show(
      //   "picker-view",
      //   operators,
      //   {
      //     title: "Мобилен оператор",
      //     buttonOKText: "",
      //     buttonCancelText: "",
      //     hideSearch: true,
      //   },
      //   opp => {
      //     if (opp != null) {
      //       var other = modelsInBom
      //         .filter(i => i.name.toLowerCase().contains(opp.toLowerCase()))
      //         .map(i =>
      //           i.name
      //             .replace(m, "")
      //             .replace("|", "")
      //             .replace(opp, "")
      //             .trim(),
      //         )
      //         .filter(m => !!m);
      //       if (other.length > 0) {
      //         this.$nextTick(() => {
      //           this.dialog.show(
      //             "picker-view",
      //             other,
      //             {
      //               title: "Разновидност",
      //               buttonCancelText: "",
      //               buttonOKText: "",
      //               hideSearch: true,
      //             },
      //             optsResult => {
      //               if (optsResult != null) {
      //                 this.$nextTick(() => {
      //                   var dev = this.root.find(r => r.name.contains(m) && r.name.contains(opp) && r.name.replace(opp, "").contains(optsResult));
      //                   if (dev) {
      //                     this.chosenModel = dev;
      //                     this.currentItem = dev;
      //                   }
      //                 });
      //               }
      //             },
      //           );
      //         });
      //       } else {
      //         var dev = this.root.find(r => r.name.contains(m) && r.name.contains(opp));
      //         if (dev) {
      //           this.chosenModel = dev;
      //           this.currentItem = dev;
      //         }
      //       }
      //     }
      //   },
      // );
    },
    appendChildren(node) {
      var ch = this.BOM.filter((b) => b.parentid == node.id && !b.analog)
        .sort((a, b) => {
          if (a.hasChild && !b.hasChild) return -1;
          else if (!a.hasChild && b.hasChild) return 1;
          else {
            if (a.name == b.name) return a.analog - b.analog;
            return a.name.localeCompare(b.name);
          }
        })
        .map((item) => ({
          ...item,
        }));
      node.children = [];
      node.children.push(...ch);
      this.searchItems.push(...ch);
      node.children.forEach((rr) => {
        this.appendChildren(rr);
      });
    },
  },
  computed: {
    treeroot() {
      return this.root instanceof Array ? this.root : [this.root];
    },
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.$nextTick(() => {
          this.booleans.isLoading = false;
        });
      }
    };
    this.$nextTick(async () => {
      if (process.env.NODE_ENV === "production") {
        await this.dialog.show("loader", null, { message: "Зареждане на номенклатурата, моля, изчакайте..." });
        HTTPSender.SendGETreq("https://a.tremol.bg/", "_Photos/BOM.json")
          .done((response) => {
            if (typeof response == "string") {
              response = JSON.parse(response);
            }
            this.BOM = response;
            this.loadTree();
            this.dialog.close();
          })
          .fail(() => {
            this.dialog.close();
            this.dialogLoader.showError("Грешка при зареждане на номенклатурата!");
          });
      } else {
        this.BOM = require("./BOM.json");
        this.loadTree();
      }
    });
    // window.onbeforeunload = () => {
    //   this.chosenModel = null;
    //   return "Your work will be lost.";
    // };
  },
  watch: {
    chosenModel(dev) {
      this.searchItems.forEach((i) => i.children.slice(0, i.children.length - 1));
      if (dev) {
        this.root = this.BOM.find((b) => b.id == dev.id);
        this.root.children = [];
        this.searchItems = [this.root];
        this.appendChildren(this.root);
        // this.root.forEach(r => {
        //   this.appendChildren(r);
        // });
        this.$nextTick(() => {
          //this.$refs.refTree.updateAll(true);
          this.searchItems.sort((a, b) => {
            if (a.hasChild && !b.hasChild) return -1;
            else if (!a.hasChild && b.hasChild) return 1;
            else return a.name.localeCompare(b.name);
          });
          //this.$refs.refTree.updateAll(true);
          this.openIds = [this.root];
        });
      } else {
        this.root = this.BOM.filter((b) => b.parentid == "0" || b.parentid == zeros);
        this.$nextTick(() => {
          this.searchItems = this.UniqueBOM;
        });
      }
    },
    // openIds(val) {
    //   console.log(val);
    // }
  },
};
</script>
<style>
.snl {
  text-align: start;
  display: inline-block;
  white-space: pre-wrap;
  width: 100%;
}
</style>

<style scoped>
.title-style {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 1rem;
}
</style>